import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MedicinePriceHistory } from '@interfaces/medicine/medicine.interface';

@Component({
  selector: 'app-medicine-price-history-edit-dialog',
  templateUrl: './medicine-price-history-edit-dialog.component.html',
})
export class MedicinePriceHistoryEditDialogComponent implements OnInit {
  public editForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { priceHistoryItem: MedicinePriceHistory },
    public dialogRef: MatDialogRef<MedicinePriceHistoryEditDialogComponent>,
    private fb: FormBuilder
  ) {
    this.editForm = this.fb.group({
      pvl: [0, [Validators.required, Validators.min(0)]],
      descuento: [0, [Validators.required, Validators.min(0), Validators.max(100)]],
      recargo: [0, [Validators.required, Validators.min(0), Validators.max(100)]],
      pvln: [{ value: 0, disabled: true }],
    });
  }

  ngOnInit(): void {
    if (this.data.priceHistoryItem) {
      this.editForm.patchValue({
        pvl: this.data.priceHistoryItem.PVL || 0,
        descuento: this.data.priceHistoryItem.Descuento || 0,
        recargo: this.data.priceHistoryItem.Recargo || 0,
        pvln: this.data.priceHistoryItem.PVLN || 0,
      });

      this.setupPvlnCalculation();
    }
  }

  get pvlControl(): FormControl {
    return this.editForm.get('pvl') as FormControl;
  }

  get descuentoControl(): FormControl {
    return this.editForm.get('descuento') as FormControl;
  }

  get recargoControl(): FormControl {
    return this.editForm.get('recargo') as FormControl;
  }

  get pvlnControl(): FormControl {
    return this.editForm.get('pvln') as FormControl;
  }

  readOnly(): boolean {
    return true;
  }

  private setupPvlnCalculation(): void {
    this.editForm.get('pvl')?.valueChanges.subscribe(() => this.calculatePvln());
    this.editForm.get('descuento')?.valueChanges.subscribe(() => this.calculatePvln());
    this.editForm.get('recargo')?.valueChanges.subscribe(() => this.calculatePvln());
  }

  private calculatePvln(): void {
    const pvl = Number(this.editForm.get('pvl')?.value || 0);
    const descuento = Number(this.editForm.get('descuento')?.value || 0);
    const recargo = Number(this.editForm.get('recargo')?.value || 0);

    const pvln = this.calculatePVLN(pvl, descuento, recargo);
    this.editForm.get('pvln')?.setValue(pvln, { emitEvent: false });
  }

  private calculatePVLN(pvl: number, descuento: number, recargo: number): number {
    return Math.round((pvl - (pvl * descuento / 100) + (pvl * recargo / 100)) * 100) / 100;
  }

  onSave(): void {
    if (this.editForm.valid) {
      const formValue = this.editForm.getRawValue();

      this.dialogRef.close({
        Id: this.data.priceHistoryItem.Id,
        DistribuidorId: this.data.priceHistoryItem.DistribuidorId,
        LaboratorioId: this.data.priceHistoryItem.LaboratorioId,
        PVL: Number(formValue.pvl),
        Descuento: Number(formValue.descuento),
        Recargo: Number(formValue.recargo),
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
